<template>
	<div class="bridge-requirements">
		<span class="skip-requirements__label">
			{{ translate("ui.bribe_text") }}
		</span>
		<div class="bridge-requirements__price">
			<span class="label"> {{ translate("ui.price") }}: </span>
			<AppPrice :amount="gemsPrice" :currency="ResourceType.GEMS" />
		</div>
		<AppTextButton
			:type="StatusTypes.SECONDARY"
			:text="translate('button.bribe_action')"
			:shadow="true"
			:disabled="isDisabled"
			@click="handleBribe"
		/>
	</div>
</template>

<script lang="ts" setup>
import AppPrice from "@/components/AppPrice.vue";
import AppTextButton from "@/components/AppTextButton.vue";
import { ResourceType } from "@/game/entities/config/resources";
import { StatusTypes } from "@/types/ui";
import { translate } from "@/utils/translate";

const props = defineProps<{
	gemsPrice: number;
	isDisabled: boolean;
	onBribe: () => void;
}>();

const emit = defineEmits(["closePopup"]);

const handleBribe = (): void => {
	props.onBribe();
	emit("closePopup");
};
</script>

<style lang="scss" scoped>
.bridge-requirements {
	@include flex-col-center;

	&__label {
		margin-bottom: 0.5rem;
		color: #372615;
		font-size: 0.875rem;
		line-height: 1rem;
		text-align: center;
	}

	&__price {
		@include flex-row-center;
		align-items: baseline;
		gap: 0.5rem;
		margin-bottom: 0.75rem;
		color: #372615;
		font-size: 0.875rem;

		span {
			font-weight: 800;
		}

		.price {
			display: inline-flex;

			:deep(.price__value) {
				color: #372615;
				font-size: 0.875rem;
				text-shadow: none;
			}
		}
	}
}
</style>
